import { TEST_SUBSCRIPTION_BADGE } from '../Common/TestSeriesListingTestCard';

import type { TestSubscriptionBadge } from './types';

export interface ApiSubscriptionFlags {
  isIconic?: boolean;
  isIconicPro?: boolean;
  isSpecial?: boolean;
}

export type SubscriptionFlagsSource = ApiSubscriptionFlags & {
  is_iconic?: boolean;
  is_iconic_pro?: boolean;
  is_special?: boolean;
};

/**
 * Backend-confirmed tier rules:
 * - isIconicPro=true → Iconic Pro
 * - isIconic=true (any isSpecial) → Iconic
 * - isIconic=false, isSpecial=true → free → Prime in UI
 * - isIconic=false, isSpecial=false → Plus
 */
export const normalizeSubscriptionFlags = (
  source: SubscriptionFlagsSource = {}
): ApiSubscriptionFlags => ({
  isIconic: Boolean(source.isIconic ?? source.is_iconic),
  isIconicPro: Boolean(source.isIconicPro ?? source.is_iconic_pro),
  isSpecial: Boolean(source.isSpecial ?? source.is_special)
});

export const isIconicTest = (flags: ApiSubscriptionFlags): boolean =>
  Boolean(flags.isIconic);

/** Free test — Prime subscription / trial in UI */
export const isFreeTest = (flags: ApiSubscriptionFlags): boolean =>
  !flags.isIconic && Boolean(flags.isSpecial);

/** Plus test — Plus subscription required */
export const isPlusTest = (flags: ApiSubscriptionFlags): boolean =>
  !flags.isIconic && !flags.isSpecial;

export const getSubscriptionBadgeFromApi = (
  flags: ApiSubscriptionFlags
): TestSubscriptionBadge => {
  if (isIconicTest(flags)) {
    return TEST_SUBSCRIPTION_BADGE.ICONIC as TestSubscriptionBadge;
  }

  if (isFreeTest(flags)) {
    return TEST_SUBSCRIPTION_BADGE.PRIME as TestSubscriptionBadge;
  }

  return TEST_SUBSCRIPTION_BADGE.PLUS as TestSubscriptionBadge;
};
